//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { map , filter } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const standardexamsInitial = [];

export const standardexams = (state = standardexamsInitial, action) => {
    switch (action.type) {
        case ActionTypes.standardexams.createStandardExamsSuccess:
            return [action.payload, ...state];
        case ActionTypes.standardexams.listStandardExamsSuccess:
            return action.payload;
        case ActionTypes.standardexams.updateStandardExamsSuccess:
            return map(state,dt=>{
                if(dt.id===action.payload.id){
                    return action.payload;
                }
                return dt;
            })
        case ActionTypes.standardexams.deleteStandardExamsSuccess:
            return filter(state,dt=>dt.id!==action.payload)
        default:
            return state;
    }
};
